import gql from 'graphql-tag';

export default gql`
subscription {
    onDeleteEtlQuery {
        __typename
        id
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlQueries/DeleteSubscription.js